import React from 'react';
import block from 'bem-cn';

import { getLogo } from './img/data';

import './Logo.scss';

const b = block('logo-domain');

const Logo = () => {
  const logoSrc = getLogo();

  return (
    <img className={b()} src={logoSrc} alt="logo" />
  );
};

export default Logo;
